module.exports = __webpack_public_path__ + "img/30. Tanaya Rele.c2ffc6e7.jpg";